<div class="profile-picture-container">
  @if (displayUrl && displayUrl !== DEFAULT_AVATAR) {
    <img
      [src]="displayUrl"
      (error)="onImageError()"
      alt="Profilbild"
      class="profile-picture"
    />
  } @else if (displayUrl === DEFAULT_AVATAR) {
    <!-- Kein Bild oder URL abgelaufen: Initialen statt Platzhalter -->
    <div
      class="user-avatar profile-picture-fallback"
      [ngStyle]="{ 'background-color': avatarBadge.color }"
    >
      {{ avatarBadge.initials }}
    </div>
  } @else {
    <!-- Solange nicht aufgelöst ist, wird bewusst kein Bild gezeigt -->
    <p-skeleton shape="circle" size="100px"></p-skeleton>
  }
  <button
    pButton
    icon="pi pi-pencil"
    class="change-picture-button"
    title="Bild ändern"
    [disabled]="uploadingImage || removingImage"
    (click)="showBildDialog()"
  ></button>
  <button
    pButton
    icon="pi pi-times"
    class="remove-picture-button"
    title="Bild entfernen"
    [loading]="removingImage"
    [disabled]="uploadingImage || removingImage"
    (click)="removeImage()"
  ></button>
</div>

<!-- appendTo="body", damit der Dialog nicht im Inhalt des übergeordneten Dialogs landet -
     dessen Ein-/Ausblend-Animation setzt ein transform und würde position: fixed brechen. -->
<p-dialog
  header="Profilbild hochladen"
  [(visible)]="displayDialog"
  [modal]="true"
  [closable]="!uploadingImage"
  appendTo="body"
  styleClass="profile-image-upload-dialog"
  [contentStyle]="{ 'background-color': '#ffffff' }"
  [style]="{ width: '500px', 'border-radius': '8px' }"
>
  <p-fileUpload
    #profileUpload
    name="files"
    (uploadHandler)="uploadImage($event)"
    customUpload="true"
    [disabled]="uploadingImage"
    [auto]="false"
    [multiple]="false"
    accept=".jpg,.jpeg,.png,.gif,.webp"
    [maxFileSize]="maxFileSize"
    chooseLabel="Bild auswählen"
    uploadLabel="Bild hochladen"
    [uploadIcon]="uploadingImage ? 'pi pi-spin pi-spinner' : 'pi pi-upload'"
    [showCancelButton]="false"
    invalidFileTypeMessageSummary="Ungültiges Dateiformat"
    invalidFileTypeMessageDetail="Erlaubt sind JPG, PNG, GIF und WebP."
    invalidFileSizeMessageSummary="Datei zu groß"
    [invalidFileSizeMessageDetail]="maxFileSizeMessage"
  >
    <!-- Ersetzt PrimeNGs vierspaltige Zeile: die zwängt jede Spalte auf 25% Breite, wodurch
         der Entfernen-Button aus dem Dialog gedrängt wurde. -->
    <ng-template pTemplate="file" let-file let-index="index">
      <div class="selected-file">
        <img [src]="file.objectURL" alt="" class="selected-file-preview" />
        <span class="selected-file-name">{{ file.name }}</span>
        <span class="selected-file-size">{{
          profileUpload.formatSize(file.size)
        }}</span>
        <button
          pButton
          type="button"
          icon="pi pi-times"
          text
          severity="secondary"
          class="selected-file-remove"
          title="Auswahl verwerfen"
          [disabled]="uploadingImage"
          (click)="profileUpload.remove($event, index)"
        ></button>
      </div>
    </ng-template>

    <ng-template pTemplate="empty">
      <div>Datei hierher ziehen, um sie hochzuladen.</div>
      <div class="upload-hint">
        JPG, PNG, GIF oder WebP · max. {{ maxFileSizeLabel }} · wird automatisch
        auf {{ profileImageSize }}×{{ profileImageSize }} verkleinert
      </div>
    </ng-template>
  </p-fileUpload>
</p-dialog>
